import React from "react";
// @ts-ignore
import avatar from "../../assets/images/avatar.png"
// @ts-ignore
import iris from "../../assets/images/iris.png";
import "./chat-header.scss";
import { IConfig } from "../../pages/ChatWindow";

interface ChatHeaderProps {
	onClose: () => void;
	config: IConfig;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ onClose, config }) => {
	return (
		<div className="chat-header">
			<div className="concierge-info">
				<div className="avatar">
					<img
						src={config?.concierge_name?.toLowerCase() === 'iris' ? iris : avatar}
						alt="Alex - Brekiya Concierge"
						onError={(e) => {
							const target = e.target as HTMLImageElement;
							target.src = `data:image/svg+xml,${encodeURIComponent('<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="#0066FF"/><text x="50%" y="50%" font-family="Arial" font-size="16" fill="white" text-anchor="middle" dy=".3em">A</text></svg>')}`;
						}}
					/>
				</div>
				<div className="concierge-details">
					<div className="concierge-name">
						{config?.concierge_name || "Alex"}
						<svg width="14" height="14" viewBox="0 0 24 24" fill="#0066FF">
							<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
						</svg>
					</div>
					<div className="online-status">
						{config?.brand_name?.[0].toUpperCase() +
							config?.brand_name?.slice(1)}{" "}
						Concierge
					</div>
				</div>
			</div>
			<button
				className="close-button"
				onClick={onClose}
				aria-label="Close chat"
			>
				<svg
					width="14"
					height="14"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
				>
					<path
						d="M18 6L6 18M6 6l12 12"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</button>
		</div>
	);
};

export default ChatHeader;
